import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { btnSearch, onExport, onImport, closeDialogView } from "../../store/fuerzaventas/cargarmiespacio/actions";

import { Body, Footer, Page } from "@sigeco/tools";
import Backdrop from "@material-ui/core/Backdrop";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";
import Icon from "@material-ui/core/Icon";

import CargaMiEspacioFilter from "../../components/fuerzaventas/cargarmiespacio/CargarMiEspacioFilter";
import CargaMiEspacioPanel from "../../components/fuerzaventas/cargarmiespacio/CargarMiEspacioPanel";
import MiEspacioArchivo from "../../components/fuerzaventas/cargarmiespacio/MiEspacioArchivo";

const CargarMiEspacio = ({ onClose, setTitle }) => {
    const loading = useSelector((state) => state.cargarmiespacio.loading);
    const store = useSelector((state) => state.cargarmiespacio.filters.band);
    const openPopup = useSelector((state) => state.cargarmiespacio.openPopup);
    const dispatch = useDispatch();

    useEffect(() => {
        setTitle("Mi Espacio");
        // eslint-disable-next-line
    }, []);

    function onBtnClose() {
        onClose();
    }

    return (
        <Page>
            <Backdrop style={{ position: "absolute", zIndex: 1200 }} open={loading} transitionDuration={0}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Body>
                <CargaMiEspacioFilter />
                <CargaMiEspacioPanel />
            </Body>
            <Footer>
                {store === true && (
                    <Button
                        color="primary"
                        size="small"
                        variant="outlined"
                        onClick={() => dispatch(onExport())}
                        startIcon={<Icon className="fas fa-file-excel" />}
                    >
                        Exportar
                    </Button>
                )}
                {store === true && (
                    <Button
                        color="primary"
                        size="small"
                        variant="outlined"
                        onClick={() => dispatch(btnSearch())}
                        startIcon={<Icon className="fas fa-search" />}
                    >
                        Buscar
                    </Button>
                )}
                {store === false && (
                    <Button
                        color="primary"
                        size="small"
                        variant="outlined"
                        onClick={() => dispatch(onImport())}
                        startIcon={<Icon className="fa fa-upload" />}
                    >
                        Importar
                    </Button>
                )}
                <Button
                    color="primary"
                    size="small"
                    variant="outlined"
                    onClick={() => onBtnClose()}
                    startIcon={<Icon className="fas fa-door-open" />}
                >
                    Salir
                </Button>
            </Footer>

            <Dialog
                fullScreen
                open={openPopup}
                style={{ overflow: "none" }}
                onClose={() => dispatch(closeDialogView())}
            >
                <AppBar position="relative" style={{ overflow: "none" }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={() => dispatch(closeDialogView())}
                            aria-label="close"
                        >
                            <Icon className="fas fa-times" />
                        </IconButton>
                        <Typography variant="h6">Detalle de archivo</Typography>
                    </Toolbar>
                </AppBar>
                <MiEspacioArchivo />
            </Dialog>
        </Page>
    );
};

export default CargarMiEspacio;
